import { flow } from 'lodash';
import Slideshow from './Slideshow';
import withUserInput from '../../hocs/UserInput';
import withPager from '../../hocs/Pager';

export default flow(withUserInput, withPager)(Slideshow);



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/index.js